import React, { useState, useEffect, useRef } from "react";
import CurrencyInput from "../../helpers/input-mask";
import Cookies from "universal-cookie";

import unorm from "unorm";

import "./CurrencyBox.scss";

export default function CurrencyBox(props) {
  const node = useRef();
  const listRef = useRef();
  const searchInput = useRef(null);

  const cookies = new Cookies();

  const [inputAmount, setInputAmount] = useState(props.value);

  const [items, setItems] = useState(props.items || []);
  const [defaultCurrency, setDefaultCurrency] = useState(props.defaultCurrency);
  const [selectedItem, setSelectedItem] = useState(
    props.selectedItem || props.items[0]
  );
  const [showItems, setShowItems] = useState(false);
  const [filterTerm, setFilterTerm] = useState("");
  const [showSelectedOptionText] = useState(
    props.showSelectedOptionText || false
  );
  const [searchPlaceholder] = useState(props.searchPlaceholder || "");

  useEffect(() => {
    setTimeout(() => {
      searchInput.current.focus();
    }, 300);
  }, [showItems]);

  /* INPUT */
  useEffect(() => {
    setInputAmount(props.value);
  }, [props.value]);

  useEffect(() => {
    setDefaultCurrency(props.defaultCurrency);
  }, [props.defaultCurrency]);

  useEffect(() => {
    setItems(props.items);
  }, [props.items]);

  function handleInputAmount(value) {
    setInputAmount(value);

    props.onInputChange(value);
  }

  useEffect(() => {
    if (
      props.selectedItem != null &&
      Object.keys(props.selectedItem).length > 0
    )
      setSelectedItem(props.selectedItem);
  }, [props.selectedItem]);

  /* DROPDOWN */
  useEffect(() => {
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", escFunction);

    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", escFunction);
    };
  });

  const handleClick = (e) => {
    if (node.current.contains(e.target)) {
      return;
    }

    closeDropdown();
  };

  const escFunction = (e) => {
    if (e.keyCode === 27) {
      closeDropdown();
    }
  };

  function shouldCreateDropdown() {
    return items.length > 1;
  }

  function closeDropdown() {
    listRef.current.scrollTop = 0;
    setShowItems(false);
  }

  function toggleDropdown() {
    if (shouldCreateDropdown()) setShowItems(!showItems);
  }

  function setCookieMoeda(id) {
    const current = new Date();
    const nextYear = new Date();

    nextYear.setFullYear(current.getFullYear() + 1);
    cookies.set("minha_moeda", id, { path: "/", expires: nextYear });
  }

  function selectItem(item) {
    setCookieMoeda(item.codigo_iso);

    setSelectedItem(item);
    closeDropdown();

    props.onDropDownChange(item);
  }

  function sanitalizeStringToSearch(string) {
    let normalizedString = unorm.nfd(string);

    string = normalizedString.toLowerCase().replace(/[\u0300-\u036f]/g, "");

    return string;
  }

  function renderList() {
    if (shouldCreateDropdown())
      return items
        .filter((item) => {
          let sanitalizedItem = sanitalizeStringToSearch(item.nome);
          let sanitalizedFilterTerm = sanitalizeStringToSearch(filterTerm);

          return sanitalizedItem.includes(sanitalizedFilterTerm);
        })
        .map((item) => {
          return (
            <>
              {showSelectedOptionText && item.id === 76 && (
                <div className="title-dropdown">Mais populares</div>
              )}
              {showSelectedOptionText && item.id === 5 && (
                <>
                  <hr className="line-divider" />
                  <div className="title-dropdown">Outros países</div>
                </>
              )}
              <div
                key={item.id}
                onClick={() => selectItem(item)}
                className={selectedItem.id === item.id ? "selected" : ""}
              >
                {item.codigo_iso != null && (
                  <span className={`flag`}>
                    {item.codigo_iso === "UM" || item.codigo_iso === "XJ" ? (
                      <span className="noFlag">?</span>
                    ) : (
                      <img
                        src={`https://www.confidencecambio.com.br/wp-content/themes/confidence/assets/img/simulador/bandeiras_new/${item.codigo_iso.toLowerCase().substring(0,2)}.svg`}
                        alt="Banderia pais"
                        className={item.codigo_iso === "EUR" ? 'flagEuro' : ''}
                      />
                    )}
                  </span>
                )}

                {item.codigo_iso != null && <span>{item.codigo_iso}</span>}

                {item.codigo_iso_bacen != null && (
                  <span className={`flag`}>
                    {item.codigo_iso_bacen === "UM" || item.codigo_iso_bacen === "XJ" ? (
                      <span className="noFlag">?</span>
                    ) : (
                      <img
                        src={`https://www.confidencecambio.com.br/wp-content/themes/confidence/assets/img/simulador/bandeiras_new/${item.codigo_iso_bacen.toLowerCase().substring(0,2)}.svg`}
                        alt="Banderia pais"
                      />
                    )}
                  </span>
                )}

                <span className={item.codigo_iso ? 'currencyName' : ''}>{item.nome.toLowerCase()}</span>
              </div>
            </>
          );
        });
  }

  return (
    <div className="c-box" ref={node}>
      <div className={"c-box-row " + (showItems ? "activeDropDown" : "")}>
        <div
          className={
            showSelectedOptionText
              ? "c-box-select--container full-width"
              : "c-box-select--container"
          }
          onClick={toggleDropdown}
        >
          <div className="c-box-select--selected-item">
            {showSelectedOptionText ? (
              <span className="c-box-current-option">{selectedItem.nome}</span>
            ) : (
              <div className="flagCurrency">
                <span
                  className={`flag flag-${
                    defaultCurrency
                      ? "BRL"
                      : selectedItem.codigo_iso
                      ? selectedItem.codigo_iso.substring(0,2)
                      : selectedItem.codigo_iso_bacen.substring(0,2)
                  }`}
                ></span>
                <span className="textCurrency">
                  {defaultCurrency
                    ? "BRL"
                    : selectedItem.codigo_iso
                    ? selectedItem.codigo_iso
                    : selectedItem.codigo_iso_bacen}
                </span>
              </div>
            )}
          </div>
          <div
            style={{ display: shouldCreateDropdown() ? "block" : "none" }}
            className="c-box-select--arrow"
          >
            <span
              className={`${
                showItems
                  ? "c-box-select--arrow-up"
                  : "c-box-select--arrow-down"
              }`}
            />
          </div>
        </div>

        {!showSelectedOptionText && (
          <div onClick={() => closeDropdown()}>
            <CurrencyInput
              inputType="tel"
              thousandSeparator="."
              decimalSeparator=","
              className="c-box-input"
              maxLength={14}
              value={inputAmount}
              onChangeEvent={(e) => handleInputAmount(e.target.value)}
            />
          </div>
        )}
        <span
          className={
            "c-box-close-dropdown " +
            (showItems && !showSelectedOptionText ? "show" : "")
          }
          onClick={closeDropdown}
        ></span>
      </div>
      <div
        ref={listRef}
        className={
          "c-box-select--items list " + (showItems ? "activeDropDown" : "")
        }
      >
        <div className="searchbar">
          <input
            type="text"
            value={filterTerm}
            onChange={(e) => setFilterTerm(e.target.value)}
            placeholder={searchPlaceholder || "Digite..."}
            ref={searchInput}
          />
        </div>
        <div className="list-options">
          <div className="itens with-flags">{renderList()}</div>
        </div>
      </div>
    </div>
  );
}
